import { generateApi } from 'utils/api'

const { selectVendor, selectVendors, useVendor, useVendors } =
  generateApi('vendor')

export { selectVendor, selectVendors, useVendor, useVendors }
